import { render, staticRenderFns } from "./ProfileSkillsConfig.vue?vue&type=template&id=68758a60&scoped=true"
import script from "./ProfileSkillsConfig.vue?vue&type=script&lang=ts"
export * from "./ProfileSkillsConfig.vue?vue&type=script&lang=ts"
import style0 from "./ProfileSkillsConfig.vue?vue&type=style&index=0&id=68758a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68758a60",
  null
  
)

export default component.exports